<!-- Created by Arga Ghulam Ahmad - arga@jojonomic.com -->
<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="notification-screen success-screen"
      @click="toggleSuccessScreen">
      <div class="notification-screen-box">
        <div class="floating-container">
          <jLottie
            :options="defaultOptions"
            :height="250"
            :width="250"
            class="animation"
            @animCreated="handleAnimation"/>
          <h1
            class="title">
            Success
          </h1>
          <h2
            id="success-screen-message"
            class="message">
            {{ message }}
          </h2>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import jLottie from '../lottie/jLottie';
import * as animationData from '../../assets/notification/success.json';

export default {
  name: 'JSuccessScreen',
  components: {
    jLottie,
  },
  props: {
    message: String,
  },
  data() {
    return {
      defaultOptions: {
        animationData,
      },
      animationSpeed: 1,
      isVisible: false,
    };
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    toggleSuccessScreen() {
      this.isVisible = !this.isVisible;
    },
    showSuccessScreen() {
      this.isVisible = true;
    },
    hideSuccessScreen() {
      this.isVisible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/notification-screen/jSuccessScreen.vue